import React, { useState } from "react";
import { plan, subPlan, td, th } from "../../Shared/Styles";
import { formatDate } from "../ProductDetails";
import useQuery from "../../../hooks/useQuery";

export const truncateDecimals = (number, digits) => {
  var multiplier = Math.pow(10, digits),
    adjustedNum = number * multiplier,
    truncatedNum = Math[adjustedNum < 0 ? 'ceil' : 'floor'](adjustedNum);

  return truncatedNum / multiplier;
};

export default function RecoveryBenefit(benefitDetails) {
  let query = useQuery();
  const [otherBenefitPlans] = useState(benefitDetails.ob);
  var isBTLife = benefitDetails?.policyOrigin !== undefined && benefitDetails?.policyOrigin === "TLIS";
  var isAsteron = ((benefitDetails?.policyOrigin !== undefined && benefitDetails?.policyOrigin === "ASTERON") || (benefitDetails?.policyOrigin !== undefined && benefitDetails?.policyOrigin === "Suncorp"));

  const [productSeries] = useState(query.get("productSeries"));
  const isSeries46 = productSeries?.toLowerCase() === "series46" ? true : false;

  function isNotEmpty(val) {
    return val === undefined || val == null || val.length <= 0 || val === "" || val === "Not Applicable" || val === 0 || val === "0" || val === "Unknown" || val === "0 Days" ? false : true;
  }

  function truncateDecimals(number, digits) {
    var multiplier = Math.pow(10, digits),
      adjustedNum = number * multiplier,
      truncatedNum = Math[adjustedNum < 0 ? 'ceil' : 'floor'](adjustedNum);

    return truncatedNum / multiplier;
  };

  if (otherBenefitPlans !== undefined) {
    return otherBenefitPlans.sort((a, b) => a.coverTypeCode > b.coverTypeCode ? 1 : -1).map((data) => {
      if (!(isBTLife || isAsteron) || (data.coverStatusName === "In Force")) {
        return (
          <>
            <React.Fragment>
              <div>
                {!isBTLife &&
                  <tbody>
                    <tr >
                      <td colSpan="2" style={{ border: '1px solid black', textAlign: 'center', fontSize: '15px', width: '6%', marginBottom: '13px', color: 'black' }}>
                        <div>
                          <p style={plan}>{data.benefitType}</p>
                        </div>
                        <p style={subPlan}>
                          {isNotEmpty(data.tpdDefinition) && (
                            <>
                              <span style={plan}>Definition:</span>
                              <span style={{ fontSize: "15px" }}>
                                {data.tpdDefinition}{" "}
                              </span>
                            </>
                          )}

                          {isNotEmpty(data.ipAgreeDIndemnity) && (
                            <>
                              <span style={plan}>IP Agreed/Indemnity:</span>
                              <span style={{ fontSize: "15px" }}>
                                {data.ipAgreeDIndemnity}{" "}
                              </span>
                            </>
                          )}

                          {isNotEmpty(data.waitingPeriod) && (
                            <>
                              <span style={plan}>Waiting Period:</span>
                              <span style={{ fontSize: "15px" }}>
                                {data.waitingPeriod}{" "}
                              </span>
                            </>
                          )}

                          {isNotEmpty(data.benefitPeriod) && (
                            <>
                              <span style={plan}>Benefit Period:</span>
                              <span style={{ fontSize: "15px" }}>
                                {data.benefitPeriod}{" "}
                              </span>
                            </>
                          )}

                          {isNotEmpty(data.employerSuperContributionAmount) && isNotEmpty(data.superContributionAmount) && (
                            <>
                              <span style={plan}>Employer Superannuation Contribution Amount:</span>
                              <span style={{ fontSize: "15px" }}>
                                {truncateDecimals(data.employerSuperContributionAmount, 2).toLocaleString("en-US", { style: 'currency', currency: 'USD' })}{" "}
                              </span>
                            </>
                          )}

                          {isNotEmpty(data.superContributionAmount) && (
                            <>
                              <span style={plan}>Super Contribution:</span>
                              <span style={{ fontSize: "15px" }}>
                                {truncateDecimals(data.superContributionAmount, 2).toLocaleString("en-US", { style: 'currency', currency: 'USD' })}{" "}
                              </span>
                            </>
                          )}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <th style={th}>Sum Insured/Monthly Benefit</th>
                      <td style={td}>{truncateDecimals(data.sumInsured, 2).toLocaleString("en-US", { style: 'currency', currency: 'USD' })}</td>
                    </tr>
                    {(isSeries46 || data?.series === 46) && data?.isTPDInstalment != null ? <tr>
                      <th style={th}>TPD Support Option</th>
                      <td style={td}>{data.isTPDInstalment ? "Y" : "N"}</td>
                    </tr> : null}
                    <tr>
                      <th style={th}>Instalment Premium</th>
                      <td style={td}>{truncateDecimals(data.instalmentPremium, 2).toLocaleString("en-US", { style: 'currency', currency: 'USD' })}</td>
                    </tr>

                    <tr>
                      <th style={th}>Annual Premium</th>
                      <td style={td}>{truncateDecimals(data.annualPremium, 2).toLocaleString("en-US", { style: 'currency', currency: 'USD' })}</td>
                    </tr>

                    <tr>
                      <th style={th}>Annual Stamp Duty</th>
                      <td style={td}>{truncateDecimals(data.annualStampDuty, 2).toLocaleString("en-US", { style: 'currency', currency: 'USD' })}</td>
                    </tr>

                    {!isAsteron && (
                      <tr>
                        <th style={th}>Annual Policy Fee</th>
                        <td style={td}>{truncateDecimals(data.annualPolicyFee, 2).toLocaleString("en-US", { style: 'currency', currency: 'USD' })}</td>
                      </tr>
                    )}

                    <tr>
                      <th style={th}>Premium Type</th>
                      <td style={td}>{data.premiumType}</td>
                    </tr>

                    <tr>
                      <th style={th}>CPI</th>
                      <td style={td}>{data.cpi}</td>
                    </tr>

                    <tr>
                      <th style={th}>Start Date</th>
                      <td style={td}>{formatDate(data.startDate)}</td>
                    </tr>

                    <tr>
                      <th style={th}>Expiry Date</th>
                      <td style={td}>{formatDate(data.expiryDate)}</td>
                    </tr>
                  </tbody>
                }

                {isBTLife && (data.coverTypeCode === "LI" || data.coverTypeCode === "TRM" || data.coverTypeCode === "REC" ||
                  data.coverTypeCode === "NDL" || data.coverTypeCode === "CHIL" || data.coverTypeCode === "TPD") &&
                  <tbody>
                    <tr >
                      <td colSpan="2" style={{ border: '1px solid black', textAlign: 'center', fontSize: '15px', width: '6%', marginBottom: '13px', color: 'black' }}>
                        <div>
                          <p style={plan}>{data.benefitType}</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th style={th}>Sum Insured</th>
                      <td style={td}>{truncateDecimals(data.sumInsured, 2).toLocaleString("en-US", { style: 'currency', currency: 'USD' })}</td>
                    </tr>

                    <tr>
                      <th style={th}>Premium Type</th>
                      <td style={td}>{data.premiumType}</td>
                    </tr>

                    <tr>
                      <th style={th}>Annual Premium</th>
                      <td style={td}>{truncateDecimals(data.annualPremium, 2).toLocaleString("en-US", { style: 'currency', currency: 'USD' })}</td>
                    </tr>

                    {/* <tr>
                  <th style={th}>Loadings</th>
                  <td style={td}>{data.HasLoadings === false ? "No": "Yes"}</td>
                </tr>                  */}

                    <tr>
                      <th style={th}>Start Date</th>
                      <td style={td}>{formatDate(data.startDate)}</td>
                    </tr>

                    <tr>
                      <th style={th}>Expiry Date</th>
                      <td style={td}>{formatDate(data.expiryDate)}</td>
                    </tr>

                    <tr>
                      <th style={th}>CPI</th>
                      <td style={td}>{data.cpi}</td>
                    </tr>

                  </tbody>
                }

                {isBTLife && (data.coverTypeCode === "BEX" || data.coverTypeCode === "BO" || data.coverTypeCode === "IP" ||
                  data.coverTypeCode === "KPI") &&
                  <tbody>
                    <tr >
                      <td colSpan="2" style={{ border: '1px solid black', textAlign: 'center', fontSize: '15px', width: '6%', marginBottom: '13px', color: 'black' }}>
                        <div>
                          <p style={plan}>{data.benefitType}</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th style={th}>Monthly Benefit</th>
                      <td style={td}>{truncateDecimals(data.sumInsured, 2).toLocaleString("en-US", { style: 'currency', currency: 'USD' })}</td>
                    </tr>

                    <tr>
                      <th style={th}>Premium Type</th>
                      <td style={td}>{data.premiumType}</td>
                    </tr>

                    <tr>
                      <th style={th}>Annual Premium</th>
                      <td style={td}>{truncateDecimals(data.annualPremium, 2).toLocaleString("en-US", { style: 'currency', currency: 'USD' })}</td>
                    </tr>

                    <tr>
                      <th style={th}>Benefit Type</th>
                      <td style={td}>{data.ipAgreeDIndemnity}</td>
                    </tr>

                    <tr>
                      <th style={th}>Benefit Period</th>
                      <td style={td}>{data.benefitPeriod}</td>
                    </tr>

                    <tr>
                      <th style={th}>Waiting Period</th>
                      <td style={td}>{data.waitingPeriod}</td>
                    </tr>

                    {/* <tr>
                  <th style={th}>Loadings</th>
                  <td style={td}>{data.HasLoadings === false ? "No": "Yes"}</td>
                </tr>                  */}

                    <tr>
                      <th style={th}>Start Date</th>
                      <td style={td}>{formatDate(data.startDate)}</td>
                    </tr>

                    <tr>
                      <th style={th}>Expiry Date</th>
                      <td style={td}>{formatDate(data.expiryDate)}</td>
                    </tr>

                    <tr>
                      <th style={th}>CPI</th>
                      <td style={td}>{data.cpi}</td>
                    </tr>

                  </tbody>
                }

                {isBTLife && (data.coverTypeCode === "IPO" || data.coverTypeCode === "LIO" || data.coverTypeCode === "TPDO" ||
                  data.coverTypeCode === "TRMO") &&
                  <tbody>
                    <tr >
                      <td colSpan="2" style={{ border: '1px solid black', textAlign: 'center', fontSize: '15px', width: '6%', marginBottom: '13px', color: 'black' }}>
                        <div>
                          <p style={plan}>{data.benefitType}</p>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th style={th}>Status</th>
                      <td style={td}>{data.coverStatusName}</td>
                    </tr>

                    <tr>
                      <th style={th}>Annual Premium</th>
                      <td style={td}>{truncateDecimals(data.annualPremium, 2).toLocaleString("en-US", { style: 'currency', currency: 'USD' })}</td>
                    </tr>

                    <tr>
                      <th style={th}>Start Date</th>
                      <td style={td}>{formatDate(data.startDate)}</td>
                    </tr>

                    <tr>
                      <th style={th}>Expiry Date</th>
                      <td style={td}>{formatDate(data.expiryDate)}</td>
                    </tr>
                  </tbody>
                }

              </div>
            </React.Fragment>
          </>
        );
      }
    });
  }
}
